import { render, staticRenderFns } from "./product-purchase.vue?vue&type=template&id=827c3bc8&scoped=true&"
import script from "./product-purchase.vue?vue&type=script&lang=js&"
export * from "./product-purchase.vue?vue&type=script&lang=js&"
import style0 from "./product-purchase.vue?vue&type=style&index=0&id=827c3bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827c3bc8",
  null
  
)

export default component.exports